/* eslint-disable no-eval */
import { locale } from '../types';
// eslint-disable-next-line
import { dump } from '../../util/debug';

export const setLanguage = (language) => (dispatch, getState, { getFirebase }) => {
  dispatch({ type: locale.CHANGE_LANGUAGE, data: { language } });
};
